// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2970":"fast-text-encoding","3628":"fxaPairingChannel","4918":"asmcrypto.js","5349":"fxaCryptoDeriver","8076":"fxa-common-password-list","8639":"webcrypto-liner"}[chunkId] || chunkId) + ".bundle.js";
};